import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { APP_CONST } from '@/constant';

(async () => {
  if (import.meta.env.MODE === 'test') return;

  i18n
    .use(initReactI18next)
    .use(HttpApi)
    .init({
      fallbackLng: APP_CONST.LANG.KO,
      ns: ['translation'],
      defaultNS: 'translation',
      fallbackNS: 'translation',
      backend: {
        loadPath: `${import.meta.env.BASE_URL}locales/{{lng}}/{{ns}}.json`,
      },
      keySeparator: '.',
      interpolation: {
        escapeValue: false,
      },
    });

  await i18n.changeLanguage(APP_CONST.LANG.KO);
})();

export default i18n;
